<mat-form-field class="w-100" appearance="outline">
  <mat-label>
    {{ placeholder }}
  </mat-label>
  <input
    matInput
    [formControl]="control"
    [matAutocomplete]="auto"
    [type]="inputType"
    (blur)="blur.emit($event)"
    [readonly]="readonly"
    name="fast-autcomplete"
    autocomplete="off"
  />
  <button
    *ngIf="controlIsEnable"
    mat-icon-button
    matSuffix
    (click)="control.value ? clearSelectValue() : null"
  >
    <i
      *ngIf="control.value"
      class="pi pi-times-circle mb-1"
      style="color: red"
    ></i>
    <i
      *ngIf="!control.value"
      class="pi pi-angle-down mb-1"
      style="color: 'var(--primary-color)'"
    ></i>
  </button>
</mat-form-field>
<small class="p-error" *ngIf="control.invalid">{{ messages[getKey()] }}</small>
<mat-autocomplete
  (blur)="blur.emit($event)"
  autoActiveFirstOption
  #auto="matAutocomplete"
  [displayWith]="displayWithEntityFn"
>
  <mat-option disabled *ngIf="isLoading" class="is-loading">
    <mat-spinner diameter="30" color="primary"></mat-spinner>
  </mat-option>
  <mat-option disabled *ngIf="noResults && control.value && !isLoading">
    Não encontramos nada com {{ control.value }}
  </mat-option>
  <mat-option disabled *ngIf="filteredEntities.length === 0">
    Não existe nenhum disponível!
  </mat-option>
  <ng-container *ngIf="!isLoading">
    <mat-option
      (onSelectionChange)="onSelect.emit(entity)"
      *ngFor="let entity of filteredEntities"
      [value]="entity"
    >
      {{ displayWithEntityFn(entity) }}
    </mat-option>
  </ng-container>
  <!-- *ngIf="!isLoading && actionState && !notShowResultsFirst" -->
  <mat-option *ngIf="false">
    <!-- (click)="openDialogFast()" -->
    <div style="display: flex; align-items: center; color:#666;">
      <i class="mdi mdi-plus"></i>
      Adicionar agora
    </div>
  </mat-option>
</mat-autocomplete>
